
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"width":"7","height":"8"}},[_c('path',{attrs:{"d":"M1.49 5.988h5.508v1.11H0V0h6.928v1.11H1.49v1.84h5.268v1.059H1.49z"}})])
      }
    
      }
    